import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryFactorModel, detectionFactor, control } from '@/api/api';
export default {
  name: 'AssetEquipmentRepairList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  data: function data() {
    return {
      pagePath: '/om/day/quality/control',
      pageTitle: '设备检修',
      Factorpara: '',
      //因子参数
      factorData: [],
      list: {},
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      visible: false,
      visible1: false,
      // 表头
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'monitorProject_dictText',
        colName: 'monitor_project',
        title: '监测项目',
        align: 'center'
      }, {
        dataIndex: 'spanValue',
        colName: 'span_value',
        title: '跨度值',
        align: 'center',
        customRender: function customRender(t, r) {
          return t ? t + ' ' + '(' + r.unitName + ')' : '';
        }
      }, {
        dataIndex: 'zeroConcentration',
        colName: 'zero_concentration',
        title: '零点标准溶液浓度',
        align: 'center',
        customRender: function customRender(t, r) {
          return t ? t + ' ' + '(' + r.unitName + ')' : '';
        }
      }, {
        dataIndex: 'spanConcentration',
        colName: 'span_concentration',
        title: '跨度标准溶液浓度',
        align: 'center',
        customRender: function customRender(t, r) {
          return t ? t + ' ' + '(' + r.unitName + ')' : '';
        }
      }, {
        dataIndex: 'commitTime',
        colName: 'commit_time',
        title: '提交时间',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '提交人',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      //弹窗表头
      column: [{
        title: '监测项目',
        dataIndex: 'title',
        key: 'monitorProject',
        align: 'center',
        width: 130,
        scopedSlots: {
          customRender: 'monitorProject'
        }
      }, {
        title: '上一周水质平均',
        dataIndex: 'avg',
        key: 'avg',
        align: 'center',
        width: 160,
        scopedSlots: {
          customRender: 'avg'
        }
      }, {
        title: '跨度值',
        dataIndex: 'spanValue',
        key: 'spanValue',
        align: 'center',
        width: 160,
        scopedSlots: {
          customRender: 'spanValue'
        }
      }, {
        title: '零点标准溶液浓度',
        dataIndex: 'zeroConcentration',
        key: 'zeroConcentration',
        align: 'center',
        width: 160,
        scopedSlots: {
          customRender: 'zeroConcentration'
        }
      }, {
        title: '跨度标准溶液浓度',
        dataIndex: 'spanConcentration',
        key: 'spanConcentration',
        align: 'center',
        width: 160,
        scopedSlots: {
          customRender: 'spanConcentration'
        }
      }],
      datas: [],
      //历史表头
      history: [{
        title: '监测项目',
        dataIndex: 'monitorProject_dictText',
        key: 'monitorProject_dictText',
        align: 'center',
        width: '20%',
        scopedSlots: {
          customRender: 'monitorProject_dictText'
        }
      }, {
        dataIndex: 'zeroConcentration',
        colName: 'zero_concentration',
        title: '零点标准溶液浓度',
        align: 'center'
      }, {
        dataIndex: 'spanConcentration',
        colName: 'span_concentration',
        title: '跨度标准溶液浓度',
        align: 'center'
      }, {
        dataIndex: 'spanValue',
        colName: 'span_value',
        title: '跨度值',
        align: 'center'
      }, {
        dataIndex: 'commitTime',
        colName: 'commit_time',
        title: '提交时间',
        align: 'center'
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '提交人',
        align: 'center'
      } // {
      //   dataIndex: 'examineTime',
      //   colName: 'examine_time',
      //   title: '审核时间',
      //   align: 'center',
      // },
      // {
      //   dataIndex: 'userId_userName',
      //   colName: 'user_id',
      //   title: '审核人',
      //   align: 'center',
      // },
      ],
      Pinformation: [],
      //因子列表
      companyList: [],
      //因子往期记录
      FactorPreviouslist: [],
      factorCode: '',
      url: {
        queryCompany: '/om/day/quality/control'
      }
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
        this.delayLoadData();
        this.factorTreeList(this.queryParam.siteId);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }
    }
  },
  created: function created() {
    this.factorTreeList(); // this.loadCompany()

    this.queryParam.status = 1;
  },
  computed: {},
  methods: {
    //加载检测因子
    factorTreeList: function factorTreeList(siteId) {
      var _this = this;

      this.Pinformation = []; // 监测因子

      queryFactorModel(siteId).then(function (res) {
        if (res.success) {
          _this.datas = [];

          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            console.log('res.result[i]', res.result[i]);

            _this.Pinformation.push(temp);

            _this.datas.push({
              title: temp.title,
              monitorProject: temp.code,
              unitName: temp.unitName,
              siteId: siteId,
              spanValue: '',
              spanConcentration: '',
              zeroConcentration: '',
              avg: temp.avg
            });
          }
        }
      });
    },
    //list站点列表code值
    handleChange: function handleChange(value) {
      this.queryParam.factorCode = '';

      for (var i = 0; i < value.length; i++) {
        var part = value[i];
        this.queryParam.factorCode = this.queryParam.factorCode + ',' + part;
      }

      console.log('this.factorCode', this.factorCode);
      console.log('this.queryParam.factorCode', this.queryParam.factorCode);
    },
    // loadCompany() {
    //   var that = this
    //   that.companyList = []
    //   getAction(this.url.queryCompany, siteId).then((res) => {
    //     // console.log('...加载站点信息......', res)
    //     if (res.success) {
    //       that.companyList = res.result
    //     }
    //   })
    // },
    //历史记录查询
    handleDetail: function handleDetail(value) {
      var _this2 = this;

      this.visible1 = true;
      this.FactorPreviouslist = [];
      var monitor = value.monitorProject;
      detectionFactor(monitor).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];

            _this2.FactorPreviouslist.push(temp);
          }
        }
      });
    },
    secret: function secret() {
      this.visible1 = false;
    },
    //设置内容
    showModal: function showModal() {
      this.visible = true;
      this.datas.forEach(function (item) {
        item.spanValue = '';
        item.spanConcentration = '';
        item.zeroConcentration = '';
      });
    },
    hideModal: function hideModal(datas) {
      var _this3 = this;

      console.log('5445', datas);
      this.visible = false; // console.log('hideModal', datas)

      this.factorData = [];
      datas.filter(function (value) {
        if (!(value.spanConcentration == '' && value.spanValue == '' && value.zeroConcentration == '')) {
          _this3.factorData.push(value);
        }
      });
      control(this.factorData).then(function (res) {
        if (res.success) {
          _this3.$notification.success({
            message: res.message
          });

          _this3.$emit('ok');

          _this3.close();
        } else {
          _this3.$notification.warning({
            message: res.message
          });
        }
      }).finally(function () {
        _this3.initTableData();
      });
    },
    filterOption: function filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};